import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'TeachersListfilter'
})
export class FilterPipeTeachers implements PipeTransform {
    transform(teachers: any, term?: any): any {
        if (term === undefined) return teachers;
        if (term === null) return teachers;

        if (teachers != null) {
            return teachers.filter(function (teacher) {
                if (teacher.name != undefined)
                    if (teacher.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return teacher;
                if (teacher.email != undefined)
                    if (teacher.email.toString().toLowerCase().includes(term.toLowerCase()))
                        return teacher;
            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/schools/teachers-list/filter.pipe.ts